var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomSpeedometer = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.8c.331 0 .6-.215.6-.48V5.88c0-.265-.269-.48-.6-.48-.331 0-.6.215-.6.48v1.44c0 .265.269.48.6.48zM19.37 10.03a.583.583 0 0 0 .824 0l1.236-1.236a.583.583 0 0 0-.824-.824L19.37 9.206a.583.583 0 0 0 0 .824zM21.6 15c0 .331.215.6.48.6h1.44c.265 0 .48-.269.48-.6 0-.331-.215-.6-.48-.6h-1.44c-.265 0-.48.269-.48.6zM10.03 10.03a.583.583 0 0 1-.824 0L7.97 8.794a.583.583 0 0 1 .824-.824l1.236 1.236a.583.583 0 0 1 0 .824zM7.8 15c0 .331-.215.6-.48.6H5.88c-.265 0-.48-.269-.48-.6 0-.331.215-.6.48-.6h1.44c.265 0 .48.269.48.6zM12 9.6s.716 4.965 1.103 5.728c.388.763 1.36 1.087 2.17.722.812-.364 1.155-1.279.768-2.042C15.653 13.244 12 9.6 12 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.383 3 3 8.383 3 15s5.383 12 12 12 12-5.383 12-12S21.617 3 15 3zM4.871 19.174A10.914 10.914 0 0 1 4.043 15C4.043 8.949 8.95 4.043 15 4.043c6.051 0 10.957 4.906 10.957 10.957 0 1.479-.297 2.887-.828 4.174H4.87z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomSpeedometer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-speedometer.4afe2bcb5c9ee3e5e9192cb75f5ffbf3.svg";